// ABOUTME: What an unlicensed course shows (DVLP-7860, requirement 7). In a license-commerce
// ABOUTME: collection a covered course offers Get access; anything else keeps "Preview Only".
import { observer } from 'mobx-react';
import { Button, ButtonProps, cn } from '@execonline-inc/execonline-ui';
import { T } from '../../../../../Translations';
import UnlicensedAction from '../../Experience/ExperienceActions/UnlicensedAction';
import licensePurchaseStore from '../Store';

interface Props {
  programFamilyId: number;
  /** Named on each option in the picker: "Includes <course>". */
  courseTitle: string;
  /** Where "Continue to enrollment" goes after a purchase made from this card. */
  experienceId: string;
  /**
   * The same settings the caller gives its Enroll button, so a buyable course's
   * button is the size and shape a licensed participant's Enroll is in that spot.
   */
  buttonProps?: ButtonProps;
}

/**
 * Deliberately no price on the card. The card footer's price slot means "this course
 * costs this much" in course-commerce collections, and both collection types are live,
 * so a license price there invites exactly the wrong inference. The price lives in
 * the prompt and the picker, which have room to say what it buys.
 */
function UnlicensedOrGetAccess({ programFamilyId, courseTitle, experienceId, buttonProps }: Props) {
  if (!licensePurchaseStore.canBuy(programFamilyId)) {
    return <UnlicensedAction />;
  }

  return (
    <Button
      color="gray"
      fullWidth
      {...buttonProps}
      className={cn('font-sans', buttonProps?.className)}
      onClick={(e) => {
        // Cards open the course on click; this button opens the picker instead.
        e.preventDefault();
        e.stopPropagation();
        licensePurchaseStore.openFromCourse(programFamilyId, courseTitle, experienceId);
      }}
      data-intercom-target="discovery-portal-get-access-button"
    >
      <T kind="Get access" />
    </Button>
  );
}

export default observer(UnlicensedOrGetAccess);
